import React, {Component} from 'react'
import {Button, Segment} from "semantic-ui-react";
import './preliminary_section.css'

export class PreliminarySection extends Component {
    render() {
        const {marked, sectionName} = this.props;
        const segmentColor = marked ? 'orange' : 'blue';
        const buttonColor = marked ? 'orange' : 'blue';
        let name = sectionName ? sectionName : 'whole section';
        const text = marked ? `Unmark this ${name} as preliminary` : `Mark this ${name} as preliminary`;
        return (
            <Segment color={segmentColor} textAlign={'center'}>
                <Button onClick={this.props.toggleSectionPreliminary} id={"preliminary-section-button"}
                        title={"section preliminary"} color={buttonColor}>{text}</Button>
            </Segment>);
    }
}
